import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

export default function getMapSiteInfo(): {
  mapSite: ComputedRef<{ zoom: number; center: number[] }>
  mapZoom: ComputedRef<number>
  mapCenter: ComputedRef<number[]>
} {
  const store = useStore()
  const mapSite: ComputedRef<{ zoom: number; center: number[] }> = computed(() => {
    return store.state.mapSite
  })
  const mapZoom: ComputedRef<number> = computed(() => {
    return mapSite.value?.zoom || 14
  })
  const mapCenter: ComputedRef<number[]> = computed(() => {
    let point = [113.23, 23.16]
    if (mapSite.value?.center) {
      const [lng, lat] = mapSite.value.center
      if (lng && lat) {
        point = [lng, lat]
      }
    }
    return point
  })

  return {
    mapSite,
    mapZoom,
    mapCenter,
  }
}
